module.exports = __webpack_public_path__ + "6901eb9f4bc2720267f18df6924d7a77.pdf";